import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import { getAppConfig, getAttributeServiceUrl } from "../utils/ReduxHelper";

const LookupService = {
  getStatuses: function(isLimited) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let queryObject = new Query({
        where: "(OBJECTID IS NOT NULL)",
        outFields: "*",
        orderByFields: "Status"
      });
      if(isLimited){
        queryObject = new Query({
          where: "(IsEstimatedOnly = 'No')",
          outFields: "*",
        });
      }
  
      return query.executeQueryJSON(rootServiceUrl + "/" + config.statuses[config.env].layerId, queryObject).then(results => {
        let statuses = [];
        if(results.features) {
          statuses = results.features.map((eaGroup) => eaGroup.attributes);
        } 
        return statuses;
      });    
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
};

export default LookupService;
